/**
 * AIPRM for ChatGPT — prompt templates injected into the ChatGPT UI
 *
 * Its single WAR entry lists ~23 files explicitly — `inject.js`, `config.js`, `client.js`,
 * `style.css` and more — with `use_dynamic_url: false`, but scopes them to the ChatGPT
 * origins (chat.openai.com and chatgpt.com). So the resources are static and fetchable at
 * a fixed URL, but only from those sites: from any other origin the fetch fails and a
 * negative result proves nothing. We probe from chat.openai.com.
 *
 * Manifest verified against version 1.4.3.19.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ojnbohmppadfgpejeebfnmnknjdlckgj';

export const aiprmForChatgpt: ExtensionDefinition = {
  id: ID,
  name: 'AIPRM for ChatGPT',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  requiredOrigin: 'https://chat.openai.com',
  notes:
    'Static WAR (use_dynamic_url:false) scoped to the ChatGPT origins, so only those ' +
    'sites can detect it. A single fetch there is conclusive.',
  signals: [
    {
      id: 'war-inject-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch inject.js — the vendor-named main injection script, static but only exposed ' +
        'to the ChatGPT origins.',
      weight: 1,
      run: () => probeFetch(ID, 'inject.js'),
    },
    {
      id: 'war-config-js',
      kind: 'web-accessible-resource',
      description: 'Fetch config.js — a second origin-scoped static script.',
      weight: 0.5,
      run: () => probeFetch(ID, 'config.js'),
    },
    {
      id: 'war-style-css',
      kind: 'web-accessible-resource',
      description: 'Fetch style.css — the AIPRM UI stylesheet, independent of the scripts.',
      weight: 0.5,
      run: () => probeFetch(ID, 'style.css'),
    },
  ],
};
